import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6 text-center">Privacy Policy</h1>
      
      <p className="text-gray-600 mb-6 text-center">Last Updated: 01/12/2025</p>
      
      <div className="prose prose-lg max-w-none">
        <p>Welcome to Vernetzung, accessible at vernetzung.com. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Platform. By accessing or using the Platform, you agree to the terms of this Privacy Policy. If you do not agree with the terms, please do not use the Platform.</p>
        
        <h2 className="mt-8 mb-4 text-2xl font-semibold">1. Information We Collect</h2>
        <p>We may collect the following types of information when you use the Platform:</p>
        
        <h3 className="mt-4 mb-2 text-xl font-semibold">a. Personal Information</h3>
        <ul className="list-disc pl-6 mb-4">
          <li><strong>Contact Information:</strong> Name, email address, phone number, or other identifiers you provide when contacting us or creating an account.</li>
          <li><strong>User Content:</strong> Any content you submit, upload, or share on the Platform, such as messages, feedback, or AI-generated interactions.</li>
        </ul>
        
        <h3 className="mt-4 mb-2 text-xl font-semibold">b. Usage Data</h3>
        <ul className="list-disc pl-6 mb-4">
          <li><strong>Log Data:</strong> IP address, browser type, operating system, referring URLs, pages visited, and timestamps.</li>
          <li><strong>Device Information:</strong> Device type, unique device identifiers, and mobile network information.</li>
          <li><strong>Cookies and Tracking Technologies:</strong> We may use cookies, web beacons, and similar technologies to track user activity and preferences.</li>
        </ul>
        
        <h3 className="mt-4 mb-2 text-xl font-semibold">c. AI-Generated Data</h3>
        <ul className="list-disc pl-6 mb-4">
          <li><strong>Input Data:</strong> Information you provide to the AI tools on the Platform, such as prompts, queries, or uploaded files.</li>
          <li><strong>Output Data:</strong> Responses, analyses, or content generated by the AI based on your input.</li>
        </ul>
        
        <h2 className="mt-8 mb-4 text-2xl font-semibold">2. How We Use Your Information</h2>
        <p>We use the information we collect for the following purposes:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>To provide, operate, and maintain the Platform;</li>
          <li>To improve, personalize, and enhance user experience;</li>
          <li>To respond to your inquiries, requests, or feedback;</li>
          <li>To analyze usage trends and optimize the Platform's performance;</li>
          <li>To use the data to train our AI models and other features of the site;</li>
          <li>To comply with legal obligations and enforce our terms of service.</li>
        </ul>
        
        <h2 className="mt-8 mb-4 text-2xl font-semibold">3. Sharing Your Information</h2>
        <p>We may share your information in the following circumstances:</p>
        <ul className="list-disc pl-6 mb-4">
          <li><strong>With Service Providers:</strong> Third-party vendors who assist us in operating the Platform (e.g., hosting, analytics, or AI tools).</li>
          <li><strong>With Your Consent:</strong> When you explicitly authorize us to share your information.</li>
        </ul>
        <p>We do not sell your personal information to third parties.</p>
        
        <h2 className="mt-8 mb-4 text-2xl font-semibold">4. Data Security</h2>
        <p>We implement reasonable security measures to protect your information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>
        
        <h2 className="mt-8 mb-4 text-2xl font-semibold">5. Your Rights and Choices</h2>
        <p>Depending on your jurisdiction, you may have the following rights regarding your personal information:</p>
        <ul className="list-disc pl-6 mb-4">
          <li><strong>Access:</strong> Request a copy of the personal data we hold about you.</li>
          <li><strong>Correction:</strong> Request corrections to inaccurate or incomplete data.</li>
          <li><strong>Deletion:</strong> Request deletion of your personal data under certain conditions.</li>
          <li><strong>Opt-Out:</strong> Opt out of receiving promotional communications or disable cookies.</li>
        </ul>
        
        <h2 className="mt-8 mb-4 text-2xl font-semibold">6. Third-Party Links</h2>
        <p>The Platform may contain links to third-party websites or services. This Privacy Policy does not apply to those third-party sites, and we are not responsible for their privacy practices. We encourage you to review their privacy policies before providing any information.</p>
        
        <h2 className="mt-8 mb-4 text-2xl font-semibold">7. Children's Privacy</h2>
        <p>The Platform is not intended for use by individuals under the age of 12. We do not knowingly collect personal information from children. If we become aware that we have collected such information, we will take steps to delete it promptly.</p>
        
        <h2 className="mt-8 mb-4 text-2xl font-semibold">8. Changes to This Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated "Last Updated" date. Your continued use of the Platform after such changes constitutes your acceptance of the revised Privacy Policy.</p>
        
        <h2 className="mt-8 mb-4 text-2xl font-semibold">9. Contact Us</h2>
        <p>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:</p>
        <p>Email: <a href="mailto:contact@vernet-zung.com" className="text-blue-600 hover:underline">contact@vernet-zung.com</a></p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;